jQuery(document).ready(function() {
    jQuery('.podcast__episode__transcript').each(function() {
        const wrapper = jQuery(this);
        const content = wrapper.find('.content');
        const fullText = content.html();
        const showMoreBtn = wrapper.find('.show-more-button');
        const showLessBtn = wrapper.find('.show-less-button');
        
        // Function to truncate text
        function truncateContent() {
            const truncated = fullText.substring(0, 550) + '...';
            content.html(truncated);
            showMoreBtn.css('display', 'flex');
            showLessBtn.css('display', 'none');
        }
        
        // Initial setup
        if (fullText.length > 550) {
            truncateContent();
        } else {
            showMoreBtn.css('display', 'none');
            showLessBtn.css('display', 'none');
        }
        
        // Show more button click
        showMoreBtn.on('click', function() {
            content.html(fullText);
            showMoreBtn.css('display', 'none');
            showLessBtn.css('display', 'flex');
        });
        
        // Show less button click
        showLessBtn.on('click', function() {
            truncateContent();
        });
    });

    jQuery('.podcast__episode__copy-link').on('click', function(e) {
        e.preventDefault();
        const $btn = jQuery(this);
        const anchor = $btn.data('anchor');
        const url = window.location.origin + window.location.pathname + '#' + anchor;

        navigator.clipboard.writeText(url).then(function() {
            jQuery('.podcast-copied-tip').remove();
            const $tip = jQuery('<span class="podcast-copied-tip"></span>').text($btn.data('copied-text'));
            $btn.append($tip);
            $tip.fadeIn(200);
            setTimeout(function() {
                $tip.fadeOut(400, function() { jQuery(this).remove(); });
            }, 1500);
        });
    });
});
